import React from 'react';
import Modal, { ModalContent, ModalHeader } from '@vromo/ui/components/Modal';
import FontAwesome from '@vromo/ui/components/FontAwesome';
import Title from '@vromo/ui/components/Title';
import theme from '@vromo/ui/components/theme';

type Props = {
    isOpen: boolean;
};

export default function ErrorModal({ isOpen }: Props) {
    return (
        <Modal isOpen={isOpen}>
            <ModalHeader style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <FontAwesome
                    icon="map-marker-question"
                    weight="duotone"
                    style={{ fontSize: '5rem', color: theme.danger }}
                />
            </ModalHeader>
            <ModalContent style={{ fontSize: '1.2rem', textAlign: 'center', maxWidth: 600 }}>
                <Title style={{ fontWeight: 600 }}>Oops.</Title>
                <p>It looks like the site/restaurant tied to this page has been deleted.</p>
                <p>Contact your administrator for help.</p>
            </ModalContent>
        </Modal>
    );
}
